import styled from 'styled-components';
import { maxWidth } from '@/assets/styles/mixins.css.js';
import vars from '@/assets/styles/vars';
import { noTouch } from '@/assets/styles/mixins.css.js';

const Logo = styled.a`
  display: flex;
  height: 84px;
  align-items: center;
  flex-shrink: 0;
  transition: opacity 0.3s ease-in;

  ${maxWidth(vars.breakpoints.tablet)`
    height: auto;
  `}

  img {
    object-fit: contain;
  }

  ${noTouch()`
    &:hover {
      opacity: ${(props) => !props.active && '0.9'};
      cursor: ${(props) => props.active && 'default'};
      transition: opacity 0.3s ease-out;
    }
  `}
`;

export default Logo;
